module.exports = __webpack_public_path__ + "img/8thwall_horizontal_white.e6bfe03c.png";